export enum LoadingStatus {
    Idle = 'idle',
    Pending = 'pending',
    Completed = 'completed',
    Failed = 'failed',
}
export type LoadingStatuses = (typeof LoadingStatus)[keyof typeof LoadingStatus];